module.exports = __webpack_public_path__ + "img/rick-e-morty.41c7c670.jpeg";